import React from "react";
import "./Switch.css";

const Switch = ({ checked, onChange, disabled = false }) => {
  return (
    <label className={`switch${disabled ? " switch--disabled" : ""}`}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => { if (!disabled) onChange(e.target.checked); }}
      />
      <span className="slider"></span>
    </label>
  );
};

export default Switch;
